import { useEffect, useRef, useState, useCallback } from 'react';
import { stripeProductsApi } from 'src/services';
import { isUserFromUK, returnFilteredPlans } from 'src/lib/utils';
import Product from 'src/models/Product';
import { Plans } from 'src/pages/deprecated/payment/types';
import {
  extractPlans,
  sortSubscriptionPlans,
} from 'src/pages/subscription-new/utils/plans.util';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import {
  setAllPlansSorted,
  setAvailablePlansWithoutDefaultCheck,
} from 'src/store/signup';

interface UsePlansForReactivationReturn {
  isLoading: boolean;
  error: string | null;
}

export const usePlansForReactivation = (): UsePlansForReactivationReturn => {
  const dispatch = useAppDispatch();
  const { allPlansSorted } = useAppSelector(state => state.signUp);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const hasFetchedRef = useRef(false);

  const fetchPlans = useCallback(async () => {
    if (allPlansSorted.length > 0) return;
    setIsLoading(true);
    setError(null);
    try {
      const response = await stripeProductsApi({
        isChallengePackage: false,
        currency: isUserFromUK() ? 'gbp' : undefined,
      });
      const productsData = response.data.products;

      const tempPlans: Plans = {};
      Object.values(productsData).forEach((productEntry: unknown) => {
        const tempProduct: Product = productEntry as Product;
        if (
          tempProduct?.metadata?.EQPlanID === '1' ||
          tempProduct?.metadata?.EQPlanID === '4' ||
          tempProduct?.metadata?.challenge ||
          tempProduct?.metadata?.isSignupAddon === 'true'
        ) {
          extractPlans(tempPlans, tempProduct);
        }
      });

      const sortedPlansArr = sortSubscriptionPlans(tempPlans);
      dispatch(setAllPlansSorted(sortedPlansArr));

      const filteredPlans = returnFilteredPlans(sortedPlansArr);
      dispatch(
        setAvailablePlansWithoutDefaultCheck([...filteredPlans].reverse())
      );
    } catch (err) {
      console.error('Error fetching plans for reactivation:', err);
      setError('Failed to load plans');
    } finally {
      setIsLoading(false);
    }
  }, [allPlansSorted.length, dispatch]);

  useEffect(() => {
    if (!hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchPlans();
    }
  }, [fetchPlans]);

  return { isLoading, error };
};
